import Vue from 'vue'
import { VueMaskDirective } from 'v-mask'
import linkifyHtml from 'linkifyjs/html'

Vue.directive('uppercase', {
    bind(el, _, vnode) {
        el.addEventListener('keyup', (e) => {
            e.target.value = e.target.value.toUpperCase()
            vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
        })
    }
})

Vue.directive('linkify', {
    bind(el, _, vnode) {
        var linkifiedHtml = linkifyHtml(el.innerHTML, {
            defaultProtocol: 'https',
            target: '_blank'
        })

        el.innerHTML = linkifiedHtml
    }
})

Vue.directive('on-visible', {
    bind(el, { arg }, vnode) {
        el.inViewport = false
    },
    inserted(el, { arg }, vnode) {
        el.observer = new IntersectionObserver(
            (entries) => {
                if (!el.inViewport && entries[0].isIntersecting) {
                    vnode.context.$emit('visible')
                    el.inViewport = true
                } else if (el.inViewport) {
                    el.inViewport = false
                    vnode.context.$emit('invisible')
                }
            },
            {
                root: arg,
                threshold: '0'
            }
        )
        el.observer.observe(el)
    },
    unbind(el, _, vnode) {
        el.observer.disconnect()
        delete el.observer
        delete el.inViewport
    }
})
Vue.directive('mask', VueMaskDirective)
